module.exports = ".ck-editor__editable .ck-horizontal-line{display:flow-root}.ck-content hr{margin:15px 0;height:1px;background:#dedede;border:0}"